import _extends from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/extends";
import _classCallCheck from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _defineProperty from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import debounce from 'debounce';
import React from 'react';
import { Animated, View } from 'react-native';
var _shouldUseScreens = true;
export function useScreens() {
  var shouldUseScreens = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  if (shouldUseScreens) {
    console.warn('react-native-screens is not fully supported on this platform yet.');
  }

  _shouldUseScreens = shouldUseScreens;
}
export function screensEnabled() {
  return _shouldUseScreens;
}

function isAnimatedValue(value) {
  return value && value.__getValue && value.addListener;
}

function isPropTruthy(prop) {
  var activeValue = prop;

  if (isAnimatedValue(prop)) {
    activeValue = prop.__getValue();
  }

  return !!activeValue;
}

export var Screen =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Screen, _React$Component);

  function Screen(props) {
    var _this;

    _classCallCheck(this, Screen);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Screen).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "listenerId", null);

    _defineProperty(_assertThisInitialized(_this), "_addListener", function (possibleListener) {
      if (_this.listenerId) throw new Error('Screen: Attempting to observe an animated value while another value is already observed.');

      if (isAnimatedValue(possibleListener)) {
        _this.listenerId = possibleListener.addListener(_this._onAnimatedValueUpdated);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_removeListener", function (possibleListener) {
      if (isAnimatedValue(possibleListener)) {
        possibleListener.removeListener(_this.listenerId);
        _this.listenerId = null;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_onAnimatedValueUpdated", function (_ref) {
      var value = _ref.value;

      _this._updateDisplay(!!value);
    });

    _defineProperty(_assertThisInitialized(_this), "_updateDisplay", function (isActive) {
      if (isActive === undefined) {
        isActive = isPropTruthy(_this.props.active);
      }

      var display = isActive ? 'flex' : 'none';

      _this.setNativeProps({
        style: {
          display: display
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setNativeProps", function (nativeProps) {
      if (_this._view) {
        _this._view.setNativeProps(nativeProps);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_setRef", function (view) {
      _this._view = view;

      _this._updateDisplay();
    });

    _this._onAnimatedValueUpdated = debounce(_this._onAnimatedValueUpdated, 10);

    _this._addListener(props.active);

    return _this;
  }

  _createClass(Screen, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._removeListener(this.props.active);
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(_ref2) {
      var nextActive = _ref2.active;
      var active = this.props.active;

      if (nextActive !== active) {
        this._removeListener(active);

        this._addListener(nextActive);

        this._updateDisplay(isPropTruthy(nextActive));

        return false;
      }

      return true;
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(Animated.View, _extends({}, this.props, {
        ref: this._setRef
      }));
    }
  }]);

  return Screen;
}(React.Component);

_defineProperty(Screen, "defaultProps", {
  active: true
});

export var ScreenContainer = View;
export var NativeScreen = View;
export var NativeScreenContainer = View;